import { useMemo } from "react"

import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"
import { ProductBaseVariantObj } from "scrivito/Objs/ProductBaseVariant/ProductBaseVariantObjClass"
import { loadMatchingProductBaseVariants } from "shared/lib/product-obj/loadProduct"

import { useVariantKey } from "./useVariantKey"

interface UseProductBaseVariantsArgs {
  productObj: ProductObj | null | undefined
  variantKey: string | null | undefined
}

const emptyMatchingPresets: ProductBaseVariantObj[] = []

export function useProductBaseVariants({
  productObj,
  variantKey
}: UseProductBaseVariantsArgs) {
  const { attributes } = useVariantKey(variantKey ?? null)

  const matchingProductBaseVariantObjs: ProductBaseVariantObj[] =
    useMemo(() => {
      return (
        loadMatchingProductBaseVariants(productObj, variantKey) ||
        emptyMatchingPresets
      )
    }, [productObj, attributes])

  if (!variantKey) {
    return {
      highestMatchingProductBaseVariantObj: null,
      matchingPresetObjs: []
    }
  }

  const highestMatchingProductBaseVariantObj =
    matchingProductBaseVariantObjs[0] ?? null

  return {
    highestMatchingProductBaseVariantObj,
    matchingProductBaseVariantObjs
  }
}
